import { TranslationService } from '@alliance/shared/translation'
import { Component, ChangeDetectionStrategy } from '@angular/core'
import { Translations } from '../localization/translations'

@Component({
  selector: 'alliance-ats-navigation-not-found-page',
  templateUrl: './not-found-page.component.html',
  styleUrls: ['./not-found-page.component.tw.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NotFoundPageComponent {
  public readonly LINKS: Array<{ path: string; label: string }> = [
    {
      path: '/projects',
      label: this.translationService.translate(this.translations.goToProjects)
    },
    {
      path: '/candidates',
      label: this.translationService.translate(this.translations.goToCandidates)
    }
  ]

  public readonly illustration = 'https://images.cf-rabota.com.ua/alliance-ats/illustrations/not-found-page.svg'

  public constructor(public translations: Translations, private translationService: TranslationService) {}

  public trackByIndex(index: number): number {
    return index
  }
}
